var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoCctv = function SvgHospitalinfoCctv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M26.91 19.67v3.19h-6.38l-2.67-6.19-.69.3 2.87 6.64h6.87v3.06h.75v-7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M21.15 15.5c.76 2.08-.31 4.37-2.39 5.13s-4.37-.31-5.13-2.39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M8.09 11.733 4.303 13.11l2.394 6.578 3.787-1.378z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M25.85 13.79 9.88 19.6l-4.02-8.11 16.91-6.16z"
  })));
};
export default SvgHospitalinfoCctv;